module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_kumamoto-dc97284864bc5435d4c88fbab379ca78.png";